import React, { useState } from "react";
import Option from "../base/Option";
import Select from "../base/Select";
import states from "./states";
const UsStatesSelect = ({
  id,
  onChange,
  ...restProps
}) => {
  const [value, setValue] = useState("");
  const renderStateOptions = () => Object.entries(states).map(([stateAbbr, stateFullName]) => /* @__PURE__ */ React.createElement(Option, {
    key: stateAbbr,
    value: stateAbbr
  }, stateFullName));
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return /* @__PURE__ */ React.createElement(Select, {
    id,
    value,
    displayValueTransform: (stateAbbr) => {
      return states[stateAbbr];
    },
    label: "state",
    onChange: (e) => {
      handleChange(e);
      if (onChange)
        onChange(e);
    },
    ...restProps
  }, renderStateOptions());
};
export default UsStatesSelect;
